import { render, staticRenderFns } from "./confirm-action.vue?vue&type=template&id=2d3654f0"
import script from "./confirm-action.vue?vue&type=script&lang=js"
export * from "./confirm-action.vue?vue&type=script&lang=js"
import style0 from "./confirm-action.vue?vue&type=style&index=0&id=2d3654f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports